<ejs-dialog #loadTemplateDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()"
  (open)="onOpen($event)">
  <ng-template #header>
    {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.template-selector-title'
    | translate}}
  </ng-template>

  <ng-template #content>
    @if (showOverview) {
      <app-field-assignment-templates-overview (rowSelected)="onTemplateSelected($event)"
        (recordDoubleClick)="onTemplateSelectedAndClose($event)">
      </app-field-assignment-templates-overview>
    }
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-primary e-flat"
              (click)="onOk()"
              [disabled]="!selectedTemplate">{{'i18n.shared.ok' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-flat" (click)="onCancel()">{{'i18n.shared.cancel' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
